import { validateIncidentsSearch } from '@incidents/features/incidents-filters';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute } from './_root';

// Admin/Operations/Finance incident management page (all-org list + triage +
// export). Regular reporters use the header drawer instead. Access is gated
// by role in route-permissions.ts; the API enforces the fine-grained
// incidents:*:any permissions.
export const incidentsManagementRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'incidents-management',
  component: lazyRouteComponent(() =>
    import('@incidents/pages/incidents-management').then((m) => ({
      default: m.IncidentsManagementPage,
    }))
  ),
  validateSearch: validateIncidentsSearch,
});
